import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FireGalleytBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.FIRE_GALLEY;
}

export default FireGalleytBuildingTileEntity;
